export default __webpack_public_path__ + "static/media/05_AnimateHalfHorizontal.b898bfae.mp4";